export const IndianCardGamesData = [
    [           //LIVE CASINO
        {
            id: 'livecasino_1',
            image_1: 'https://auraimgs.imgix.net/indian%20games%20posters-31.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format',
            image_2: 'https://winbuzz360.com/assets/images/casino/livecasino/Super+Over.webp',
            name: 'Super Over',
            eventName: 'superover',
            eventId: '3060',
            tested: false,
            gameId: "EZU-cricketwar",
            tableId: "EZU",
        },
        {
            id: 'livecasino_2',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-27.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: 'https://winbuzz360.com/assets/images/casino/livecasino/3+Cards+Judgement.webp',
            name: '3 Cards Judgements',
            eventName: '3cardj',
            eventId: '3039',
            tested: false,
            gameId: "EZU-threecardpoker",
            tableId: "EZU",
        },
        {
            id: 'livecasino_3',
            image_1: 'https://auraimgs.imgix.net/indiangamesposters-04.webp?q=65&amp; w=600&amp;px=auto&amp;auto=format',
            image_2: 'https://winbuzz360.com/assets/images/casino/livecasino/Live+Teenpatti.webp',
            name: 'Teenpatti',
            eventName: 'teen',
            eventId: '3031',
            tested: false,
            gameId: "EZU-teenpatti",
            tableId: "EZU",
        },
        {
            id: 'livecasino_4',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-02.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: 'https://winbuzz360.com/assets/images/casino/livecasino/Teenpatti+T20.webp',
            name: 'Teen Patti T20',
            eventName: 'teen20',
            eventId: '3030',
            tested: false,
            gameId: "EZU-teenpatti",
            tableId: "EZU",
        },
        {
            id: 'livecasino_5',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-25.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: 'https://winbuzz360.com/assets/images/casino/livecasino/Teenpatti+Test.webp',
            name: 'Teenpatti Test',
            eventName: 'teen9',
            eventId: '3048',
            tested: false,
            gameId: "EZU-teenpatti",
            tableId: "EZU",
        },
        {
            id: 'livecasino_6',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-23.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: 'https://winbuzz360.com/assets/images/casino/livecasino/Teenpatti+Open.webp',
            name: 'Open Teenpatti',
            eventName: 'teen8',
            eventId: '3049',
            tested: false,
            gameId: "EZU-teenpatti",
            tableId: "EZU",
        },
        {
            id: 'livecasino_7',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-24.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: 'https://winbuzz360.com/assets/images/casino/livecasino/dragon_tiger.avif',
            name: 'Dragon Tiger',
            eventName: 'dt20',
            eventId: '3035',
            tested: false,
            gameId: "EZU-dragontiger",
            tableId: "EZU",
        },
        {
            id: 'livecasino_8',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-09.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: 'https://winbuzz360.com/assets/images/casino/livecasino/32+cards+casino.webp',
            name: '32 Card Casino',
            eventName: 'card32',
            eventId: '3055',
            tested: false,
            gameId: "EZU-32cards",
            tableId: "EZU",
        },
        {
            id: 'livecasino_9',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-12.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: 'https://winbuzz360.com/assets/images/casino/livecasino/Bollywood+Casino.webp',
            name: 'Bollywood Casino',
            eventName: 'btable',
            eventId: '3041',
            tested: false,
            gameId: "EZU-casinoholdem",
            tableId: "EZU",
        },
        {
            id: 'livecasino_10',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-11.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: 'https://winbuzz360.com/assets/images/casino/livecasino/Amar+Akbar+Anthony.webp',
            name: 'Amar Akbar Anthony',
            eventName: 'aaa',
            eventId: '3056',
            tested: false,
            gameId: "NE-bollywoodstory",
            tableId: "NE",
        },
        {
            id: 'livecasino_11',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-13.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: "https://winbuzz360.com/assets/images/casino/livecasino/Baccarat.webp",
            name: 'Baccarat',
            eventName: 'baccarat',
            eventId: '3044',
            tested: false,
            gameId: "EZU-baccarat",
            tableId: "EZU"
        },
        {
            id: 'livecasino_12',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-29.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: "https://winbuzz360.com/assets/images/casino/livecasino/29+Card+Baccarat.webp",
            name: '29 Card Bacarrat',
            eventName: 'baccarat2',
            eventId: '3033',
            tested: false,
            gameId: "EZU-baccarat",
            tableId: "EZU"
        },
        {
            id: 'livecasino_13',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-22.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: "https://winbuzz360.com/assets/images/casino/livecasino/Casino+War.webp",
            name: 'Casino War',
            eventName: 'war',
            eventId: '3038',
            tested: false,
            gameId: "EZU-casinoholdem",
            tableId: "EZU"
        },
        {
            id: 'livecasino_14',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-05.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: "https://winbuzz360.com/assets/images/casino/livecasino/Andar+Bahar.webp",
            name: 'Andar Bahar',
            eventName: 'ab20',
            eventId: '3053',
            tested: false,
            gameId: "EZU-andarbahar",
            tableId: "EZU"
        },
        {
            id: 'livecasino_15',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-08.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: "https://winbuzz360.com/assets/images/casino/livecasino/Poker.webp",
            name: 'Poker',
            eventName: 'poker',
            eventId: '3051',
            tested: false,
            gameId: "WOO-tricardpoker",
            tableId: "WOO"
        },
        {
            id: 'livecasino_16',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-10.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: "https://winbuzz360.com/assets/images/casino/livecasino/Poker+20-20.webp",
            name: '20 - 20 Poker',
            eventName: 'poker20',
            eventId: '3052',
            tested: false,
            gameId: "WOO-tricardpoker",
            tableId: "WOO"
        },
        {
            id: 'livecasino_17',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-03.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: "https://winbuzz360.com/assets/images/casino/livecasino/Worli+Matka.webp",
            name: 'Worli Matka',
            eventName: 'worli',
            eventId: '3054',
            tested: false,
            gameId: "KGL-deeprush",
            tableId: "KGL"
        },
        {
            id: 'livecasino_18',
            image_1: "https://cdn.mac88.com/mac88/vr_casinometer.webp",
            image_2: "https://cdn.mac88.com/mac88/vr_casinometer.webp",
            name: 'Casino Meter',
            eventName: 'cmeter',
            eventId: '3046',
            tested: false,
            gameId: "EZU-casinoholdem",
            tableId: "EZU"
        },
        {
            id: 'livecasino_19',
            image_1: "https://tezcdn.io/casino/mac88-500*299/blue/race20.webp",
            image_2: "https://tezcdn.io/casino/mac88-500*299/blue/race20.webp",
            name: 'Race 20 - 20',
            eventName: 'race20',
            eventId: '3036',
            tested: false,
            gameId: "BTG-theracemegaways",
            tableId: "BTG"
        },
        {
            id: 'livecasino_20',
            image_1: "https://tezcdn.io/casino/mac88-500*299/blue/lucky7.webp",
            image_2: "https://tezcdn.io/casino/mac88-500*299/blue/lucky7.webp",
            name: 'Lucky 7',
            eventName: 'lucky7',
            eventId: '3058',
            tested: false,
            gameId: "BTG-theracemegaways",
            tableId: "BTG"
        },
        {
            id: 'livecasino_21',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-09.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: 'https://winbuzz360.com/assets/images/casino/livecasino/32+cards+casino.webp',
            name: '32 Card B',
            eventName: 'card32eu',
            eventId: '3034',
            tested: false,
            gameId: "EZU-32cards",
            tableId: "EZU",
        },
        {
            id: 'livecasino_22',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-24.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: 'https://winbuzz360.com/assets/images/casino/livecasino/dragon_tiger.avif',
            name: 'Dragon Tiger 2',
            eventName: 'dt202',
            eventId: '3059',
            tested: false,
            gameId: "EZU-dragontiger",
            tableId: "EZU",
        },
        {
            id: 'livecasino_23',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-05.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: "https://winbuzz360.com/assets/images/casino/livecasino/Andar+Bahar.webp",
            name: 'Andar Bahar 2',
            eventName: 'abj',
            eventId: '3043',
            tested: false,
            gameId: "EZU-andarbahar",
            tableId: "EZU"
        },
        {
            id: 'livecasino_24',
            image_1: "https://tezcdn.io/casino/mac88-500*299/blue/lucky7.webp",
            image_2: "https://tezcdn.io/casino/mac88-500*299/blue/lucky7.webp",
            name: 'Lucky 7 - B',
            eventName: 'lucky7eu',
            eventId: '3032',
            tested: false,
            gameId: "BTG-theracemegaways",
            tableId: "BTG"
        },
        {
            id: 'livecasino_25',
            image_1: "https://cdn.mac88.com/mac88/cricket2020.webp",
            image_2: "https://cdn.mac88.com/mac88/cricket2020.webp",
            name: 'Cricket Match 20',
            eventName: 'cmatch20',
            eventId: '3045',
            tested: false,
            gameId: "BTG-theracemegaways",
            tableId: "BTG"
        },
        {
            id: 'livecasino_26',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-24.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: 'https://winbuzz360.com/assets/images/casino/livecasino/dragon_tiger.avif',
            name: '1 Day Dragon Tiger',
            eventName: 'dt6',
            eventId: '3057',
            tested: false,
            gameId: "EZU-dragontiger",
            tableId: "EZU",
        },
        {
            id: 'livecasino_27',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-20.webp?q=65&w=625&ar=0.75&px=auto&auto=format&fit=fill&blur=0",
            image_2: 'https://auraimgs.imgix.net/indian%20games%20posters-20.webp?q=65&w=625&ar=0.75&px=auto&auto=format&fit=fill&blur=0',
            name: 'Queen',
            eventName: 'queen',
            eventId: '3037',
            tested: false,
            gameId: "EZU-dragontiger",
            tableId: "EZU",
        },
        {
            id: 'livecasino_28',
            image_1: "https://auraimgs.imgix.net/indian%20games%20posters-03.webp?q=65&amp;w=600&amp;px=auto&amp;auto=format",
            image_2: "https://winbuzz360.com/assets/images/casino/livecasino/Worli+Matka.webp",
            name: 'instant Worli',
            eventName: 'worli2',
            eventId: '3040',
            tested: false,
            gameId: "KGL-deeprush",
            tableId: "KGL"
        },
    ],








    [              //vIRTUAL CASINO
        {
            id: "virtualcasino_1",
            image_2: "https://winbuzz360.com/assets/images/casino/virtualcasino/Baccarat+(Virtual).webp",
            name: 'Baccarat',
            gameId: "HAK-baccarat",
            tableId: "HAK"
        },
        {
            id: "virtualcasino_2",
            image_2: "https://winbuzz360.com/assets/images/casino/virtualcasino/Race+20-20+(Virtual).webp",
            name: 'Race 20 - 20',
            gameId: "EVO-firstpersonvideopoker",
            tableId: "EVO"
        },
        {
            id: "virtualcasino_3",
            image_2: "https://winbuzz360.com/assets/images/casino/virtualcasino/Amar+Akbar+Anthony+(Virtual).webp",
            name: 'Amar Akbar Anthony',
            gameId: "RTG-akbarromeowalter",
            tableId: "RTG"
        },
        {
            id: "virtualcasino_4",
            image_2: "https://winbuzz360.com/assets/images/casino/virtualcasino/Poker+20-20+(Virtual).webp",
            name: '20 - 20 Poker',
            gameId: "EVO-firstpersonvideopoker",
            tableId: "EVO"
        },
        {
            id: "virtualcasino_7",
            image_2: "https://winbuzz360.com/assets/images/casino/virtualcasino/Queen+(virtual).webp",
            name: 'Queen Race',
            gameId: "EVO-dreamcatcher",
            tableId: "EVO"
        },
        {
            id: "virtualcasino_10",
            image_2: "https://winbuzz360.com/assets/images/casino/virtualcasino/Casino+War+(Virtual).webp",
            name: 'Casino War',
            gameId: "PNG-3handcasinoholdem",
            tableId: "PNG"
        },
        {
            id: "virtualcasino_11",
            image_2: "https://winbuzz360.com/assets/images/casino/virtualcasino/Casino+Meter+(Virtual).webp",
            name: 'Casino Meter',
            gameId: "PNG-3handcasinoholdem",
            tableId: "PNG"
        },
        {
            id: "virtualcasino_12",
            image_2: "https://winbuzz360.com/assets/images/casino/virtualcasino/Bollywood+Casino+(Virtual).webp",
            name: 'Bollywood Casino',
            gameId: "PNG-3handcasinoholdem",
            tableId: "PNG"
        },
        {
            id: "virtualcasino_15",
            image_2: "https://winbuzz360.com/assets/images/casino/virtualcasino/Andar+Bahar+(Virtual).webp",
            name: 'Andar Bahar',
            gameId: "RTG-andarbahar",
            tableId: "RTG"
        },
        {
            id: "virtualcasino_17",
            image_2: "https://winbuzz360.com/assets/images/casino/virtualcasino/Dragon+Tiger+(Virtual).webp",
            name: 'Dragon Tiger',
            gameId: "PG-dragontiger",
            tableId: "PG"
        },
        {
            id: "virtualcasino_19",
            image_2: "https://winbuzz360.com/assets/images/casino/virtualcasino/32+cards+casino+(Virtual).webp",
            name: '32 Card Casino',
            gameId: "PNG-3handcasinoholdem",
            tableId: "PNG"
        },
        {
            id: "virtualcasino_21",
            image_2: "https://winbuzz360.com/assets/images/casino/virtualcasino/Poker++(Virtual).webp",
            name: 'Poker',
            gameId: "GA-caribbeanstudpoker",
            tableId: "GA"
        },
        {
            id: "virtualcasino_22",
            image_2: "https://winbuzz360.com/assets/images/casino/virtualcasino/Six+player+poker+(Virtual).webp",
            name: 'Six Player Poker',
            gameId: "WAZ-americanpokerv",
            tableId: "WAZ"
        },
        {
            id: "virtualcasino_23",
            image_2: "https://winbuzz360.com/assets/images/casino/virtualcasino/Roulette+(Virtual).webp",
            name: 'Roulette',
            gameId: "SWC-europeanroulette",
            tableId: "SWC"
        }
      ]
      
];